import VueRouter, { Route, RouteConfig } from 'vue-router';
import state from '@/store';
import { requireAuthenticated, requireStaff, multiguard } from '@/utils';
// import Layout from './Layout.vue';
// import Layout from '@/Layout.vue';
import ReportHomePage from './pages/CustomReportHome.vue';
import CustomReportView from './pages/CustomReportView.vue';
import CustomReportPageView from './pages/CustomReportPageView.vue';

const APP_ICON = 'fa-chart-line';
const APP_NAME = 'Report';

const app = { name: APP_NAME, icon: APP_ICON };

const createBreadcrumbs = (breadcrumbs: Array<Record<string, any>>) => () => breadcrumbs;

const routes: Array<RouteConfig> = [
    {
        path: '/customreport',
        name: 'customreport-home',
        component: ReportHomePage,
        meta: {
            app,
            breadcrumbs: createBreadcrumbs(
                [
                    {
                        disabled: true, exact: true, link: true, text: 'Reports', to: { name: 'customreport-home' },
                    },
                ],
            ),
        },
        beforeEnter: requireAuthenticated,
    },
    {
        path: '/customreport/view/:reportId',
        props: true,
        name: 'customreport-view',
        component: CustomReportView,
        meta: {
            app,
            breadcrumbs: createBreadcrumbs(
                [
                    {
                        disabled: false, exact: true, link: true, text: 'Reports', to: { name: 'customreport-home' },
                    },
                    {
                        disabled: true, exact: true, link: true, text: 'View', to: { name: 'customreport-view' },
                    },
                ],
            ),
        },
        beforeEnter: requireAuthenticated,
    },
    {
        path: '/customreport/view/:reportId/:pageId',
        props: true,
        name: 'customreport-page-view',
        component: CustomReportPageView,
        meta: {
            app,
            breadcrumbs: createBreadcrumbs(
                [
                    {
                        disabled: false, exact: true, link: true, text: 'Reports', to: { name: 'customreport-home' },
                    },
                    {
                        disabled: false, exact: true, link: true, text: 'View', to: { name: 'customreport-view' },
                    },
                ],
            ),
        },
        beforeEnter: requireAuthenticated,
    },
];

// EXPORT
export default routes;
